import AxiosClient from "./axiosClient";

const DeviceApi = {
    add: (params) => {
        const url = "device/add"
        return AxiosClient.post(url, params)
    }
}

export default DeviceApi